import script from "./DomainsRegisterBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainsRegisterBoard.vue?vue&type=script&setup=true&lang=js"

import "./DomainsRegisterBoard.vue?vue&type=style&index=0&id=1c2c83f8&lang=scss"

const __exports__ = script;

export default __exports__